import { useState } from 'react'
import ParticlesBackground from './ParticlesBackground.jsx'
import Tools from './Tools.jsx'

export default function Services() {
  const [loaded, setLoaded] = useState(false)

  return (
    <div className="mnd-section-container services-section">
      {/* Particles sit absolutely at z-index 0, content above at z-index 1 */}
      {loaded && <ParticlesBackground />}
      <div className="services-content">
        <div className="upper-gradient"></div>
        <div className="services-mnd-mnd-e" id="services">
          <div className="container second">
            <h3>Dev Tools</h3>
            <Tools onImagesLoaded={() => setLoaded(true)} />
          </div>
        </div>
        <div className="lower-gradient"></div>
      </div>
    </div>
  )
}
